"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapPositionsToUnitaryMovements = void 0;
const blockwise_1 = require("./index");
const rxjs_1 = require("rxjs");
/**
 * Maps the position of a
 * moving block to movements,
 * only when value is 1 and either
 * vertically or horizontally.
 *
 * Other values are ignored.
 *
 * @includeExample ./src/map-positions-to-unitary-movements.example.ts
 */
function mapPositionsToUnitaryMovements() {
    return function (source) {
        return source.pipe((0, rxjs_1.pairwise)(), (0, rxjs_1.map)(function ([previous, next]) {
            return Object.assign(Object.assign({}, blockwise_1.UNIT_BLOCK), { x: next.x - previous.x, y: next.y - previous.y });
        }), (0, rxjs_1.filter)(function (move) {
            switch (move.x) {
                case -1:
                case 1:
                    return move.y === 0;
                case 0:
                    switch (move.y) {
                        case -1:
                        case 1:
                            return true;
                    }
            }
        }));
    };
}
exports.mapPositionsToUnitaryMovements = mapPositionsToUnitaryMovements;
